import { useEffect } from 'react';
import genEventBus from './genEventBus';

const GlobalEventEmitter = Symbol.for('EventEmitter')
// eventBus
export const ee = window[GlobalEventEmitter] || genEventBus();
window[GlobalEventEmitter] = ee;

export function useEventAction (type, cb) {
	useEffect(() => {
		ee.on(type, cb);
		return () => {
			ee.removeListener(type, cb);
		};
	}, [type, cb]);
}

export function dispatch (opt, payload) {
	let type;
	if (typeof opt === 'string') {
		type = opt;
	} else if (Object.prototype.toString.call(opt) === '[object Object]' && typeof opt.type === 'string') {
		type = opt.type;
		payload = opt.payload;
	} else {
		throw new Error('dispatch内容格式不正确');
	}
	ee.emit(type, { type, payload });
}
